/* Commit server-rendered purchase data before notifying UI consumers.
   Both linked-product navigation and native variant selection use this entry
   point. Inventory and preorder eligibility remain owned by Liquid/Shopify. */
(function () {
  'use strict';
  function apply({ html, scope }) {
    if (!html || !scope) return false;
    const main = document.querySelector('[id^="MainProduct-"]');
    const isMain = scope === document || scope === main;
    if (!isMain) {
      window.AlAsilDeliveryPromise?.refreshVariant(scope, html);
      return false; // Quick views must not alter the global product bar.
    }
    const source = html.querySelector('#sticky-cart-variants, #linked-options-sticky-cart-variants');
    if (!source) throw new Error('Missing server-rendered purchase data');
    const data = JSON.parse(source.textContent);
    const input = main?.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
    // A model landing page has no purchasable selection until every axis is set.
    if (main?.dataset?.familyModelSelected === 'false') {
      if (input || data.selectedVariantId !== null || !data.variants || Object.keys(data.variants).length !== 0) throw new Error('Purchase data does not match the unselected model');
      document.querySelectorAll('#sticky-cart-variants').forEach(node => { node.textContent = source.textContent; });
      document.getElementById('sticky-cart')?.querySelector('.sticky-cart__express-form')?.remove();
      document.dispatchEvent(new CustomEvent('alasil:purchase-updated', { detail: { variantId: null } }));
      return true;
    }
    const selectedId = String(input?.value || data.selectedVariantId || '');
    if (!data.variants?.[selectedId] || (data.selectedVariantId != null && String(data.selectedVariantId) !== selectedId)) throw new Error('Purchase data does not match the selected variant');
    document.querySelectorAll('#sticky-cart-variants').forEach(node => { node.textContent = source.textContent; });
    window.AlAsilDeliveryPromise?.refreshVariant(document, html);

    // Shopify payment widgets have product-specific markup; never reuse an
    // accelerated checkout form from the previous linked product.
    const sticky = document.getElementById('sticky-cart');
    const oldExpress = sticky?.querySelector('.sticky-cart__express-form');
    const newExpress = html.querySelector('#sticky-cart .sticky-cart__express-form');
    if (newExpress && sticky) {
      if (oldExpress) oldExpress.replaceWith(newExpress.cloneNode(true));
      else sticky.appendChild(newExpress.cloneNode(true));
    } else if (oldExpress && html.querySelector('#sticky-cart')) oldExpress.remove();
    document.dispatchEvent(new CustomEvent('alasil:purchase-updated', {
      detail: { variantId: selectedId }
    }));
    return true;
  }
  window.AlAsilProductPurchase = { apply };
})();
